import React from 'react';

import APIClient from '../util/APIClient';

export default function useApiData(props) {
  const { path, params } = props;
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const reload = React.useCallback(
    (updateLoadingStatus = false) => {
      if (updateLoadingStatus) {
        setIsLoading(true);
      }
      APIClient.get(path, {
        params: params || {},
      })
        .then((result) => {
          setData(result.data);
          setError(null);
        })
        .catch((e) => {
          setError(e);
          setData(null);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [params, path],
  );

  React.useEffect(() => {
    reload();
  }, []);

  return { data, error, isLoading, reload };
}
